import { Navigate } from "react-router-dom";

function BaseComponent() {
  return <Navigate to="/login" />;
}

export default BaseComponent;
